export default __webpack_public_path__ + "static/media/buy.abce9c47.jpg";